import { TreeNode } from '@ali-hm/angular-tree-component';
import { Observable } from 'rxjs';

type TreeDropdownItemTemplateCallbackType = string | Observable<string> | Promise<string> | null;

export interface ITreeDropdownItem {
  template: (node: TreeNode) => TreeDropdownItemTemplateCallbackType;
  class?: string | string[];
  action: (node: TreeNode) => any;
}

export interface INbTreeviewOptions {
  idAttribute?: string;
  labelAttribute?: string;
  childrenAttribute?: string;
  expandedAttribute?: string;
  lazyLoadingAttribute?: string;
  checkboxAttribute?: string;
  indeterminateAttribute?: string;

  enableNodeDropdown?: boolean;
  dropdownItems?: ITreeDropdownItem[];
}

export const defaultOptions: INbTreeviewOptions = {
  idAttribute: 'id',
  labelAttribute: 'label',
  childrenAttribute: 'children',
  expandedAttribute: 'expanded',
  lazyLoadingAttribute: 'hasChildren',
  checkboxAttribute: 'enableCheckbox',
  indeterminateAttribute: 'indeterminate',

  enableNodeDropdown: false,
  dropdownItems: [],
};
